"use strict";

window.sendPianoTrackingEvent = (buttonType, eventName = 'btn_clicked') => {
  window.googleSendEvent('Premium', eventName, buttonType);
  window.facebookMetaPixelSendEvent('track', `${eventName}_${buttonType}`);
};
window.logPianoError = error => {
  console.error(`[Piano customEvent]: The JSON within "external-event-params" is not valid. \n ${error}`);
};

/**
 * TODO: Not quite sure what first line does, but it is integrated in all
 * other piano handles so I suppose it interacts with user if Ad blocker is
 * turned on.
 *
 * I user is authenticated it prepares source link for KeksPay.
 * If browser is recognized as mobile, it gets deep link from backend.
 * If browser is recognized as desktop, passes QR code source in related modal.
 */
window.showPianoPaymentCustomView = async (vendor, term) => {
  if (window.tp.util.getAdblockStatus() === 1) window.tp.template.close();
  const userToken = window.getUserToken();
  if (userToken) {
    const profileData = window.getProfileData();
    const baseQuickPayUrl = `/quickpay/piano/${vendor}/${term}/${profileData.id}`;
    let buyUrlQuery = `success_url=${window.location.href}`;
    if (vendor === 'aircash') {
      const baseUrl = `${window.location.origin}${window.location.pathname}`;
      buyUrlQuery = `success_url=${baseUrl}?quickpay_aircash=success`;
      buyUrlQuery += `&decline_url=${baseUrl}?quickpay_aircash=decline`;
      buyUrlQuery += `&cancel_url=${baseUrl}?quickpay_aircash=cancel`;
    }
    const qrSource = `${baseQuickPayUrl}?${buyUrlQuery}`;
    let paymentUrl;
    window.showGeneralLoader();
    try {
      const deepLinkResponse = await fetch(`${baseQuickPayUrl}/deep-link?${buyUrlQuery}`, {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });
      const deepLinkData = await deepLinkResponse.json();
      paymentUrl = deepLinkData.deep_link;
    } catch (e) {
      console.error(`[Piano] Deep Link for '${vendor}' not reached: ${e}`);
    }
    const paymentTitleMap = {
      'kekspay': 'Plaćanje putem KEKS Paya',
      'aircash': 'Plaćanje putem Aircasha'
    };
    if (vendor === 'kekspay') {
      window.Unicorn.call('piano-custom-payment', 'show', vendor, qrSource, `${paymentUrl}?${buyUrlQuery}`, paymentTitleMap[vendor]);
    } else if (vendor === 'aircash') {
      window.open(paymentUrl);
    }
    window.hideGeneralLoader();
  } else {
    window.openModalLogin();
  }
};
window.triggerPianoPaymentCustom = (vendor, params) => {
  const pianoData = params.split('***');
  try {
    const termData = JSON.parse(pianoData[0]);
    const buttonType = JSON.parse(pianoData[1]).element;
    termData.vendor = vendor;
    window.showPianoPaymentCustomView(vendor, termData.term);
    window.sendPianoTrackingEvent(buttonType);
  } catch (e) {
    window.logPianoError(e);
  }
};

/**
 * Gets Piano data that is usually used in `tp` (tinypass) related scripts.
 */
window.getPianoRefData = async userToken => {
  const pianoUserRefUrl = `${window.baseApiUrl}/users/me/user-ref`;
  const headers = window.structuredClone(window.baseHeadersJsonApi);
  headers.Authorization = `Bearer ${userToken}`;
  try {
    const pianoRefResponse = await fetch(pianoUserRefUrl, {
      headers
    });
    if (pianoRefResponse.status === 200) {
      return window.kitsuCore.deserialise(await pianoRefResponse.json());
    }
    console.warn(`[Piano] Data not successfully fetched from '${pianoUserRefUrl}' endpoint! ` + `Returned status "${pianoRefResponse.status}". Check response log.`);
  } catch (error) {
    console.error(`[Piano] There was a problem with fetch of data from '${pianoUserRefUrl}' endpoint! Error: ${error}`);
  }
};

/**
 * In case `tp.experience.execute` raises some error re-try execution for couple of times (3).
 * If not successful, log final error message to console.
 */
let executePianoTryCounts = 0;
const executePianoExperience = () => {
  if (executePianoTryCounts < 3) {
    executePianoTryCounts += 1;
    try {
      if (window.tp.experience) {
        window.tp.experience.execute();
      } else {
        setTimeout(() => {
          executePianoExperience();
        }, 1000);
      }
    } catch (e) {
      console.error(`[PIANO] Experience did not executed because of ${e}`);
      setTimeout(() => {
        executePianoExperience();
      }, 2000);
    }
  } else {
    console.error(`[PIANO] Experience tried to execute ${executePianoTryCounts} times, but something was not right. ` + 'Check console for errors.');
  }
};

/**
 * Used for set of Piano user reference when user is anonymous
 */
let setAnonymousRefTries = 0;
const setPianoAnonymousRef = () => {
  setAnonymousRefTries += 1;
  if (window.tp.setUserRef) {
    window.tp.setUserRef();
    executePianoExperience();
  } else if (setAnonymousRefTries < 4) {
    setTimeout(() => {
      setPianoAnonymousRef();
    }, 500);
  }
};

/**
 * If userToken exists call endpoint for getting user reference.
 * Upon successful fetch, attach method on 'pianoUnlockContent' event
 * set received user reference, and execute Piano experience.
*/
document.addEventListener('pianoSetUserRef', async () => {
  const userToken = window.getUserToken();
  if (userToken) {
    const pianoRefData = await window.getPianoRefData(userToken);
    if (pianoRefData.data && pianoRefData.data.user_ref) {
      window.tp.push(['setUserRef', pianoRefData.data.user_ref]);
      executePianoExperience();
    } else {
      console.error('[Piano] pianoRefData does not include `user_ref`. Experience cannot be executed');
    }
  } else {
    setPianoAnonymousRef();
  }
});
document.addEventListener('BaseDataLoaded', async () => {
  document.dispatchEvent(new Event('pianoSetUserRef'));
  const urlParams = new URLSearchParams(window.location.search);
  const aircashStatus = urlParams.get('quickpay_aircash');
  if (aircashStatus) {
    let title = 'Aircash';
    if (aircashStatus === 'success') {
      title = `${title}: Uspješna kupnja!`;
    } else if (aircashStatus === 'decline') {
      title = `${title}: Transakcija odbijena`;
    } else if (aircashStatus === 'cancel') {
      title = `${title}: Transakcija otkazana`;
    }
    window.showGeneralLoader();
    window.Unicorn.call('modal-quickpay', 'show', 'aircash', aircashStatus, title);
  }
});